<template>
  <div v-if="productStore.product?.additional_information?.length" class="mt-4 hidden md:flex md:flex-col">
    <div class="flex justify-center !border-b border-neutral-200">
      <UiButton
        id="product-detail-additional-information"
        variant="none"
        class="!rounded-none border-b border-primary-700 !px-3 !py-2"
      >
        <UiText size="xl">{{ $t('product.additionalInformation') }}</UiText>
      </UiButton>
    </div>
    <div class="m-10 overflow-hidden rounded-xl border border-neutral-200">
      <div
        v-for="item in productStore.product?.additional_information"
        :key="item.name"
        class="grid grid-cols-3 [&:not(:last-child)]:border-b [&:not(:last-child)]:border-b-neutral-200"
      >
        <div :class="['bg-neutral-50 px-8 py-4']">
          <UiText>{{ item.name }}</UiText>
        </div>
        <div class="col-span-2 px-8 py-4">
          <UiText>{{ item.value }}</UiText>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useProductStore } from '~/stores/product/productStore';

const productStore = useProductStore();
</script>
